


var title = "";
var body;
var icon;
var sound;
var data;
var tag;
var dir = 'auto';
var lang = 'en-US';
var renotify = false;
var sticky = false;
var vibrate = [];
var noscreen = false;
var silent = false;
var closeDelay = 0;


function checkCompatibility() {
    return !!('Notification' in window);
}

function isPermissionGranted(permission) {
    return permission === 'granted';
}

function requestPermission(callback) {
    return Notification.requestPermission(callback);
}


function close(notification) {
    if (closeDelay) {
        setTimeout(() => {
            notification.close();
        }, closeDelay);
    } else {
        notification.close();
    }
}

function closeAll() {
    Notification.close();
}

function attachEventHandlers(notification) {
    notification.onshow = () => {
        onShow.emit({ notification });
    };

    notification.onclick = (event) => {
        onClick.emit({ event, notification });
    };

    notification.onerror = () => {
        onError.emit({ notification });
    };

    notification.onclose = () => {
        onClose.emit({ notification });
    };
}

function create() {
    let notification = new Notification(title, {
        dir: dir,
        lang: lang,
        data: data,
        tag: tag,
        body: body,
        icon: icon,
        silent: silent,
        sound: sound,
        renotify: renotify,
        sticky: sticky,
        vibrate: vibrate,
        noscreen: noscreen
    });

    // attachEventHandlers(notification);
    close(notification);

    return notification;
}

function show() {
    if (!checkCompatibility()) {
        return console.log('Notification API not available in this browser.');
    }

    return requestPermission((permission) => {
        if (isPermissionGranted(permission)) {
            create();
        }
    });
}

export function showNotification(notificationTitle, notificationBody, notificationIcon, notificationSound, notificationCloseDelay) {
    title = notificationTitle;
    body = notificationBody;
    icon = notificationIcon;
    sound = notificationSound;
    closeDelay = notificationCloseDelay;
    show();
}
